module.exports = __webpack_public_path__ + "static/media/logo-gray.0de92071.png";